import type {
  ClaudeSession,
  Command,
  ConversationTurnEntry,
} from '@/features/events/conversation/state/types'
import { isInteractable } from '@/features/events/conversation/state/types'

export interface UserOption {
  readonly index: number
  readonly option: string
}

export function shouldRenderUserOptions(
  event: ConversationTurnEntry,
  session: ClaudeSession,
): boolean {
  if (!event.notificationContext?.agentDialogue?.userOptions?.length) return false
  return isInteractable(session)
}

export function isUserOptionsActive(
  event: ConversationTurnEntry,
  latestEvent: ConversationTurnEntry | null,
  userCommands: Command[],
): boolean {
  if (latestEvent?.eventId !== event.eventId) return false
  return !userCommands.some((cmd) => cmd.refEventId === event.eventId)
}

export function isQuestionnaireActive(
  event: ConversationTurnEntry,
  latestEvent: ConversationTurnEntry | null,
  userCommands: Command[],
): boolean {
  if (latestEvent?.eventId !== event.eventId) return false
  return !userCommands.some((cmd) => cmd.refEventId === event.eventId && cmd.userAnswers !== null)
}
